import { ContactCenterLogo } from '@components/ContactCenterLogo';
import LoadingIndicator from '@components/LoadingIndicator/LoadingIndicator';

import { Stack, StackItem } from '@servicetitan/design-system';

type PageLoadingProps = {
  showLogo?: boolean;
};

const PageLoading = ({ showLogo }: PageLoadingProps) => {
  return (
    <Stack
      alignContent='center'
      className='h-100vh'
      direction='column'
      justifyContent='center'
      spacing={4}
    >
      <>
        {showLogo && (
          <StackItem alignSelf='center'>
            <ContactCenterLogo showIcon />
          </StackItem>
        )}
        <StackItem alignSelf='center'>
          <LoadingIndicator show={true} size='small' />
        </StackItem>
      </>
    </Stack>
  );
};

export default PageLoading;
